import React from 'react'
import './toggle-switch.scss'
const ToggleSwitch = ({ value, name, changeState, customName }) => {


  return (
    <div className='switch-parent'>
      <label className='switch'>
        {
          customName ? <span className='switch-text small-text'>{customName}</span> : <span className='switch-text'>Yes &#8192; No &#8192; </span>

        }
        <input type="checkbox" checked={value} onChange={changeState} name={name} />
        <span className='slider'></span>
      </label>
    </div>

  )
}

export default ToggleSwitch